import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Retesting_Testing_Filter from "./retesting_testing_filter/Retesting_Testing_Filter";
import Retesting_Testing_Table from "./retesting_testing_table/Retesting_Testing_Table";
import { useDispatch, useSelector } from "react-redux";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Retesting_Testing = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.retesting_testing_report.Report,
  );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Retesting_Testing_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Retesting_Testing_Table
            validitydetails={validitydetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </section>
  );
};

export default Retesting_Testing;
